import { gql } from "@/services/httpAdapter";

export const onCreateAutoAlertsSetup = gql`
	subscription onCreateAutoAlertSetup($_id: String) {
		onCreateAutoAlertSetup(_id: $_id) {
			_id
			title
			createdOn
			createdBy {
				_id
				fullName
			}
			lastModifiedBy {
				_id
				fullName
			}
			itemsCount
			lastModifiedOn
			effectiveDateTo
			effectiveDateFrom
		}
	}
`;

export const onDeleteAutoAlertsSetup = gql`
	subscription onDeleteAutoAlertsSetup($_id: String) {
		onDeleteAutoAlertsSetup(_id: $_id) {
			_id
			title
		}
	}
`;

export const onUpdateAutoAlertsSetup = gql`
	subscription onUpdateAutoAlertsSetup($_id: String) {
		onUpdateAutoAlertsSetup(_id: $_id) {
			_id
			title
			createdOn
			itemsCount
			lastModifiedOn
			effectiveDateTo
			effectiveDateFrom
			items {
				_id
				activityType {
					_id
					description
				}
				actionType {
					_id
					description
					customerInitiated
				}
				alertDate
				initiatedBy
				associationWindow
				commission {
					input
					value
				}
				createdAt
				createdBy {
					_id
					fullName
				}
				lastModifiedOn
			}
		}
	}
`;

export const onAddAutoAlertItem = gql`
	subscription onAddAutoAlertItem($_id: String) {
		onAddAutoAlertItem(_id: $_id) {
			_id
			title
			createdOn
			itemsCount
			lastModifiedOn
			effectiveDateTo
			effectiveDateFrom
			items {
				_id
				activityType {
					_id
					description
				}
				actionType {
					_id
					description
					customerInitiated
				}
				alertDate
				initiatedBy
				associationWindow
				commission {
					input
					value
				}
				createdAt
				createdBy {
					_id
					fullName
				}
				lastModifiedOn
			}
		}
	}
`;

export const onDeleteAutoAlertItems = gql`
	subscription onDeleteAutoAlertItems($_id: String) {
		onDeleteAutoAlertItems(_id: $_id) {
			_id
			title
			createdOn
			itemsCount
			lastModifiedOn
			effectiveDateTo
			effectiveDateFrom
			items {
				_id
				activityType {
					_id
					description
				}
				actionType {
					_id
					description
					customerInitiated
				}
				alertDate
				initiatedBy
				associationWindow
				commission {
					input
					value
				}
				createdAt
				createdBy {
					_id
					fullName
				}
				lastModifiedOn
			}
		}
	}
`;

export const onUpdateAutoAlertItem = gql`
	subscription onUpdateAutoAlertItem($_id: String) {
		onUpdateAutoAlertItem(_id: $_id) {
			_id
			title
			createdOn
			itemsCount
			lastModifiedOn
			effectiveDateTo
			effectiveDateFrom
			items {
				_id
				activityType {
					_id
					description
				}
				actionType {
					_id
					description
					customerInitiated
				}
				alertDate
				initiatedBy
				associationWindow
				commission {
					input
					value
				}
				createdAt
				createdBy {
					_id
					fullName
				}
				lastModifiedOn
			}
		}
	}
`;
